import { useSelector } from "react-redux";
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function HeadingV2(props: { type: 'Knowledge Base' | 'Tickets', backMethod?: any, showBack?: boolean }) {

  const design = useSelector((state: any) => state?.design);
  const environment = useSelector((state: any) => state?.environment);

  const close = () => {
    const botpenguin = new (window as any).parent.BotPenguin();
    botpenguin.closeWindow();
    localStorage.setItem('bp-user-close', 'true');
  };


  return (
    <>
      <div id='ele-46' className="p-4 bg-bpPrimary rounded-xl flex flex-row justify-between h-full text-white" style={{ backgroundColor: design.themeColor || '#226CF4' }}>

        <div id='ele-47' className="flex flex-row justify-start align-middle items-center">

          {
            props.showBack && <ArrowBackIcon className="align-middle !text-2xl text-white cursor-pointer mr-4" onClick={props.backMethod} />            
          }

          <div id='ele-48'>
            {props.type}
          </div>

        </div>

        {
          environment && environment.viewType === 'launcher-icon' &&
          <div id='ele-49' className="cursor-pointer hover:opacity-70" onClick={close}>
            <CancelIcon className="align-middle !text-3xl" />
          </div>
        }

      </div >

    </>
  )
}
